import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AsyncClickDirective } from 'app/directives/async-click/async-click.directive';

@NgModule({
  declarations: [AsyncClickDirective],
  exports: [AsyncClickDirective],
  imports: [
    CommonModule
  ]
})
export class AsyncClickModule {
  constructor() { }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/directives/async-click/async-click.module.ts